export const reviews = [
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 5,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 3,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 4,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 5,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 3,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 4,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 5,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 3,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
    {
        review: 'Orci molestie nam vulputate nunc habitant gravida. Interdum vitae vivamus ipsum aliquet consectetur.',
        star: 4,
        name: 'Ronald Richards',
        designation: 'CEO- Utlta'
    },
]